import { Box, makeStyles } from "@material-ui/core";
import React from "react";
import { useLocation } from "react-router-dom";
import { useHasDependents } from "../hooks";
import routes from "../routes";
import Icons from "../utils/icons";
import { imageShouldBeShortened } from "../utils/shortImage";

const useStyles = makeStyles((theme) => ({
  image: {
    maxHeight: "63.5rem",
    [theme.breakpoints.between("md", "lg")]: {
      maxHeight: "39.5rem",
    },
  },
  shortImage: {
    maxHeight: "63.5rem",
    [theme.breakpoints.between("md", "lg")]: {
      maxHeight: "33rem",
    },
  },
}));

interface Image {
  path: string;
  image: any;
}

const images: Image[] = [
  {
    path: routes.reviewSelection.thankYou,
    image: Icons.ThankyouXL
  },
  {
    path: routes.eligibility.base,
    image: Icons.EligibilityXL
  },
  {
    path: routes.subscriberInfo.base,
    image: Icons.SubInfoXL
  },
  {
    path: routes.dependentInfo.base,
    image: Icons.DependentInfoXL
  },
  {
    path: routes.reviewSelection.base,
    image: Icons.ReviewXL
  },
];

const getImage = (pathname: string) => {
  return images.find((image: Image) => pathname.includes(image.path))?.image;
}

export const ImagePanel = () => {
  const classes = useStyles();
  const { pathname } = useLocation();
  const { hasDependents } = useHasDependents();
  const image = getImage(pathname);
  const shorten = imageShouldBeShortened(pathname, hasDependents);

  return (
    <Box>
      <img
        alt="right-panel"
        className={shorten ? classes.shortImage : classes.image}
        src={image}
        loading="lazy"
      />
    </Box>
  );
};